var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningBlueFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 9.6017C0.600098 14.5644 4.63756 18.6018 9.60023 18.6018C14.5629 18.6018 18.6004 14.5644 18.6004 9.6017C18.6004 4.63902 14.5629 0.601562 9.60023 0.601562C4.63756 0.601562 0.600098 4.63902 0.600098 9.6017Z",
    fill: "#1752AF",
    stroke: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59989 15.151C9.20281 15.151 8.87988 14.828 8.87988 14.4309C8.87988 14.0339 9.20281 13.7109 9.59989 13.7109C9.99698 13.7109 10.3199 14.0339 10.3199 14.4309C10.3199 14.828 9.99698 15.151 9.59989 15.151Z",
    fill: "#1752AF",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24023 11.072V6.03188C9.24023 5.83316 9.40116 5.67188 9.60024 5.67188C9.79932 5.67188 9.96025 5.83316 9.96025 6.03188V11.072C9.96025 11.2707 9.79932 11.432 9.60024 11.432C9.40116 11.432 9.24023 11.2707 9.24023 11.072Z",
    fill: "#1752AF",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlueFill);
export default __webpack_public_path__ + "static/media/WarningBlueFill.86f37434d63f84727aade2dd0b3734ca.svg";
export { ForwardRef as ReactComponent };